
export default function CompanyStory() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Founded in 2018 by Jerry Lee Jr, OED Tiny Homes and Glamping Retreat Developments began with a simple vision: 
                to create extraordinary outdoor experiences that connect people with nature while providing sustainable, 
                luxury accommodations.
              </p>
              <p>
                With over 15 years of experience in tiny home construction and hospitality development, Jerry recognized 
                the growing demand for unique, eco-friendly travel experiences. What started as a passion project has 
                evolved into a leading developer of premium glamping destinations across the Southeast.
              </p>
              <p>
                Today, we specialize in developing and managing luxury glamping retreats that offer investors attractive 
                returns while providing guests with unforgettable experiences in some of the most beautiful natural 
                settings in Alabama and beyond.
              </p>
              <p>
                Our commitment to sustainability, quality construction, and exceptional guest service has made us a 
                trusted partner for investors seeking to enter the rapidly growing glamping market.
              </p>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/600286346c3694c31d9f280bc35dbe1e.jpg"
              alt="Jerry Lee Jr - Founder of OED Glamping"
              className="rounded-lg shadow-lg w-full h-80 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
